interface LiveTradePageRow {
  readonly timestamp: string;
  readonly outcomeIndex: number;
}

/**
 * A live staircase needs one trade before the visible edge for every outcome
 * that traded inside the window. Pagination may stop as soon as those anchors
 * are present; quiet outcomes need no trade history.
 */
export function liveTradePagesNeedMore(
  rows: readonly LiveTradePageRow[],
  cutoffMs: number,
): boolean {
  const activeOutcomes = new Set<number>();
  const anchoredOutcomes = new Set<number>();

  for (const row of rows) {
    const timestampMs = Date.parse(row.timestamp);
    if (!Number.isFinite(timestampMs)) continue;
    const outcomeIndex = row.outcomeIndex;
    if (timestampMs < cutoffMs) anchoredOutcomes.add(outcomeIndex);
    else activeOutcomes.add(outcomeIndex);
  }

  for (const outcomeIndex of activeOutcomes) {
    if (!anchoredOutcomes.has(outcomeIndex)) return true;
  }
  return false;
}
